'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function MessageWithFallback(_ref) {
  var children = _ref.children,
      _ref$component = _ref.component,
      component = _ref$component === undefined ? _reactIntl.FormattedMessage : _ref$component,
      intl = _ref.intl,
      props = _objectWithoutProperties(_ref, ['children', 'component', 'intl']);

  if (intl.messages[props.id]) {
    var Component = component;
    return _react2.default.createElement(Component, props);
  }
  return children;
}

MessageWithFallback.propTypes = {
  id: _react.PropTypes.string.isRequired,
  intl: _reactIntl.intlShape,
  component: _react.PropTypes.instanceOf(_react2.default.Component),
  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node])
};

exports.default = (0, _reactIntl.injectIntl)(MessageWithFallback);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/localization-message-with-fallback/lib/components/MessageWithFallback.component.js
// module id = 1425
// module chunks = 1